import { FunctionComponent } from 'react';
import { Modal, Image } from 'react-bootstrap';
import cn from 'classnames';
import styles from "./SponsoredUserDetails.module.css";
import CustomButton, { ButtonRadiusSize, ButtonType } from '../../../../../component/common/CustomButton/CustomButton';
import { IFieldTheme } from '../../../../../component/common/FormField/FormField';
import { ASSESTS } from '../../../../../constant/assest';
import FormTextArea from '../../../../../component/common/FormField/FormTextArea';

interface IProps {
    showModal: boolean;
    onClose: () => void;
    className?: string;
};

const SponsoredUserDetails: FunctionComponent<IProps> = ({ showModal, onClose, className }) => {
    return (
        <Modal
            show={showModal}
            className={cn(styles.addModal, className)}
            dialogClassName={styles.addModalDialog}
            contentClassName={styles.addModalContent}
            centered={true}
        >
            <CustomButton
                className={styles.modalCloseBtn}
                btnType={ButtonType.IMAGE}
                onClick={onClose}
            >
                <Image src={ASSESTS.CLOSEPOPUP} alt="Close" />
            </CustomButton>
            <Modal.Header bsPrefix={styles.header}>
                <Modal.Title bsPrefix={styles.title} as={'div'}>Sponsored User Details</Modal.Title>
                <Modal.Title bsPrefix={styles.summary} as={'div'}>view detailed information about the sponsored user</Modal.Title>
            </Modal.Header>
            <Modal.Body bsPrefix={styles.body}>
                <div className={styles.userWrap}>
                    <div className={styles.user}>
                        <div className={styles.userImage}>
                            <Image src={ASSESTS.DUMMYUSER} alt="John Smith" width={36} height={36} />
                        </div>
                        <div className={styles.userData}>
                            <div className={styles.name}>John Smith</div>
                            <div className={styles.email}>John@email.com</div>
                        </div>
                    </div>
                    <div className={styles.userStatus}>
                        <span className="statusBadge active">Active</span>
                        <span className="statusBadge inactive">Inactive</span>
                    </div>
                </div>
                <div className={styles.userDetails}>
                    <div className={cn(styles.userDetailsCol, styles.joiningDate)}>
                        <div className={styles.label}>Joining Date</div>
                        <div className={styles.value}>12/02/2024</div>
                    </div>
                    <div className={cn(styles.userDetailsCol, styles.promotedDate)}>
                        <div className={styles.label}>Promoted on</div>
                        <div className={styles.value}>18/03/2025</div>
                    </div>
                    <div className={cn(styles.userDetailsCol, styles.userRecorder)}>
                        <span className="roleBadge editor">Promote user</span>
                        <span className="roleBadge support">Demote user</span>
                    </div>
                </div>
                <FormTextArea
                    className={styles.textArea}
                    fieldTheme={IFieldTheme.LIGHT2}
                    label={'Promotional Script'}
                    placeholder='Professional angler with 10+ years of experience. Specializes in bass fishing and tournament competitions.'
                />
            </Modal.Body>
            <Modal.Footer bsPrefix={styles.footer}>
                <CustomButton
                    className={styles.addBtn}
                    btnType={ButtonType.GREEN}
                    btnRadius={ButtonRadiusSize.SMALL}
                >
                    Send update to users
                </CustomButton>
            </Modal.Footer>
        </Modal>
    );
}

export default SponsoredUserDetails;